import { render, staticRenderFns } from "./AllergyForm.vue?vue&type=template&id=529c8614&"
import script from "./AllergyForm.vue?vue&type=script&lang=js&"
export * from "./AllergyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports